var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7659 17.9981H1.23288C0.875624 17.9981 0.545505 17.8075 0.366878 17.4981C0.188252 17.1887 0.188254 16.8075 0.366885 16.4981L9.63288 0.498114C9.81166 0.189226 10.1415 -0.000976562 10.4984 -0.000976562C10.8553 -0.000976562 11.1851 0.189226 11.3639 0.498114L20.6299 16.4981C20.8084 16.8074 20.8085 17.1883 20.6301 17.4977C20.4518 17.807 20.122 17.9977 19.7649 17.9981H19.7659ZM9.49988 12.9981V14.9981H10.4329H10.4979H10.5629H11.4979V12.9981H9.49988ZM9.49988 5.99811V10.9981H11.4999V5.99811H9.49988Z",
    fill: "#B00303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.4ac6b05bb4dcad55090faa808cc20fb6.svg";
export { ForwardRef as ReactComponent };